import { LightbulbQuestionOutlineIcon } from './LightbulbQuestionOutlineIcon';

/**
 * author: Michael Irigoyen
 * id 8EFBF4AB-73DD-41EC-BF3C-2503A5BDF93E
 * name lightbulb-question-outline
 * version: 6.6.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/lightbulb-question-outline.svg
 * tags
 * - Home Automation 
 */
export const LightbulbHelpOutlineIcon = LightbulbQuestionOutlineIcon;
export default LightbulbHelpOutlineIcon